export default __webpack_public_path__ + "static/media/gallery_four.d7d4006f.jpg";